import React, {Component} from 'react';
import Error from '../../ui_core/message/errors';
import './style/infoPage.css';

class schedulePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:    {},
            message: {},
        };
        this.getData = props.tools.getData.bind(this);
    }

    componentDidMount() {
        this.getData('/log/queue-length')
            .then(data => {
                this.setState({ data });
            });
    }

    render() {
        const install_ID = (function () {
            const searchObj = {};
            const paramArr = window.location.search.slice(1).split('&');

            paramArr.forEach((item) => {
                const keyVal = item.split('=');
                searchObj[keyVal[0]] = keyVal[1];
            });

            return searchObj['installationId'];
        }());

        return (
            <div className="pageBlock">
                {Object.keys(this.state.message).length ?
                    <Error {...this.state.message} /> :
                    <div className="infoPageWrapper">{Object.keys(this.state.data).length ?
                        <div id="config-panel" className="container-fluid container-page">
                            <div className="config-details-master panel panel-default clearfix">
                                <div className="panel-heading" data-loc="">
                                    <h1 className="panel-title">Support Information</h1>
                                    <hr className="separator"/>
                                </div>
                                <div className="panel-body ">
                                    <dl>
                                        <dt>Emails in queue:</dt>
                                        <dd>{this.state.data.size}</dd>
                                        <br/>
                                        <dt>Service URL:</dt>
                                        <dd>{window.location.href}</dd>
                                        <br/>
                                        <dt>Instance Id:</dt>
                                        <dd>{install_ID}</dd>
                                        <br/>
                                    </dl>
                                </div>
                            </div>
                        </div> : <div className="loading">Loading...</div> }</div>}
            </div>
        );
    }
}

export default schedulePage;